export const SET_ERROR = 'SET_ERROR'
export const UNSET_ERROR = 'UNSET_ERROR'

export const setError = (errorMessage) => ({
  type: SET_ERROR,
  errorMessage
})

export const unsetError = () => ({
  type: UNSET_ERROR,
})



// WEBPACK FOOTER //
// ./src/redux/actions/errorActions.js